export default "__VITE_ASSET__CmhQBSK___"